export function parseQueryFromHref(href: string): Record<string, string> {
  const vars: Record<string, string> = {};
  const queryIndex = href.indexOf('?');
  if (queryIndex === -1) return vars;
  const queryString = href.slice(queryIndex + 1);
  const pairs = queryString.split('&');
  for (let i = 0; i < pairs.length; i++) {
    const [key, value] = pairs[i].split('=');
    if (key !== undefined) {
      vars[key] = value ?? '';
    }
  }
  if (vars['l'] === 'navar') {
    vars['l'] = 'nav';
  }
  return vars;
}
